<div class="dialog">
  <h1>Unexpected Error</h1>
  <p class="content">There was an unexpected error loading this page.</p>
  <p class="buttons content">
    <button class="btn btn-primary" (click)="reload()">Retry</button>
  </p>
</div>
